<template>
  <div class="input-row submit check">
    <label class="input-label submit" @click="requestFormSubmit">
      <input
        class="input-submit"
        type="submit"
        name="submit"
        role="button"
        alt="Elküldöm az adatokat!"
        :value="getLabel()"
      />
    </label>
  </div>
</template>

<script>
import Config from "@/config.js";
import { EventBus } from "@/main.js";

export default {
  name: "RowSubmit",
  props: {
    id: {
      type: String,
      default: "",
      required: true
    }
  },
  created: function() {
    //this.$log.debug(this);
    /*this.$on("form:requestsubmit", function() {
      this.$log.debug("event form:submit detected");
      this.$parent.sendForm();
    });*/
  },
  data: function() {
    return {
      clicked: false
    };
  },
  computed: {},
  filters: {},
  methods: {
    getLabel: function() {
      return Config[this.id].label;
    },
    requestFormSubmit: function() {
      EventBus.$emit("form:requestsubmit");
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
//Add "scoped" attribute to limit CSS to this component only
//@import "@/scss/_variables.scss";   //imported globally

.input-row.submit {
  position: relative;
  display: block;
  box-sizing: border-box;
  margin: 0px;
  padding: 0; //0.5em 3em 1em 0px;
  font-size: 1em;

  .input-label {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 1.5em;
    line-height: 1.5em;
    min-height: 1.5em;
    margin: 0px;
    padding: 1em; //1em 1.5em 1em 0.5em;

    font-family: $font-family-normal;
    color: $colorWhite;
    background-color: $colorRed;
    border: none;
    border-radius: 25px; //3px;

    .input-submit {
      position: absolute;
      display: block;
      box-sizing: border-box;
      font-size: 1em;
      line-height: 100%;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      margin: 0px;
      padding: 0px 1.5em 0px 0.5em;
      border: none;
      background-color: $colorTransparent;
      color: $colorWhite;
      z-index: 2;
      cursor: pointer;
      letter-spacing: 0.5px;

      transition-timing-function: ease;
      transition-duration: 0.5s;
      transition-property: letter-spacing;
    }

    &:after {
      position: absolute;
      display: block;
      box-sizing: border-box;
      content: "";
      top: 0.75em;
      right: 3.75em;
      width: 0.55em;
      height: 0.55em;
      border-top: 1px solid $colorWhite;
      border-right: 1px solid $colorWhite;
      transform-origin: center;
      transform: rotate(45deg);
      z-index: 1;

      transition-timing-function: ease;
      transition-duration: 0.5s;
      transition-property: width, height, top, border-top-width,
        border-right-width;
    }

    // &:hover {
    //   &:after {
    //     border-top-width: 2px;
    //     border-right-width: 2px;
    //     width: 0.75em;
    //     height: 0.75em;
    //     top: 0.75em;
    //     right: 3.75em;

    //     transition-timing-function: ease;
    //     transition-duration: 0.5s;
    //     transition-property: width, height, top, border-top-width,
    //       border-right-width;
    //   }

    // .input-submit {
    // letter-spacing: 0px;

    // transition-timing-function: ease;
    // transition-duration: 0.5s;
    // transition-property: letter-spacing;
    // }
    // }
  }
}
</style>
